import type { UsageGroupView } from '../types/documents.types'

export const sortUsages = (
  groups: ReadonlyArray<UsageGroupView>
): UsageGroupView[] =>
  [...groups].sort((a, b) => a.title.localeCompare(b.title, 'fr'))
